<template>
  <div class="rank-table-container">
    <!-- 标题栏 -->
    <div class="header-content" style="align-items: center;">
      <div style="font-size: 24px;color: white;">新游资讯</div>
      <div style="font-size: 20px;font-weight:bold;margin-top: 1%">{{ displayTime }}</div>
    </div>

    <!-- 功能按钮（暂未开放） -->
    <div class="header-buttons" style="display: flex; justify-content: center; gap: 10px; margin-bottom: 20px;">
      <el-button
          type="primary"
          @click="goSubscribe"
          style="margin-right: 10px; background-color: #C280FF;"
      >
        订阅玩法上新+活动特别关注
      </el-button>
      <el-button type="primary" @click="showNotAvailable" style="margin-right: 10px;">厂商上传活动信息</el-button>
      <el-button type="primary" @click="showNotAvailable">加入互动玩法榜交流群</el-button>
    </div>

    <!-- 查询条件部分 -->
    <div class="search-container background-box">
      <div style="margin-right: 2%;font-weight: bold;">玩法名:</div>
      <!-- 自定义搜索框和下拉框 -->
      <div class="custom-autocomplete" style="min-width:45%;margin-right:3%;">
        <input
            v-model="searchQuery"
            type="text"
            placeholder="请输入玩法名"
            @focus="showDropdown"
            @input="onSearchInput"
            @blur="hideSuggestions"
            class="autocomplete-input"
        />
        <div v-if="showSuggestions" class="autocomplete-dropdown" :style="dropdownStyle">
          <ul>
            <li
                v-for="item in filteredSuggestions"
                :key="item.value"
                @click="onGameSelect(item)"
                class="dropdown-item"
            >
              {{ item.label }}
            </li>
          </ul>
        </div>
      </div>

      <!-- 榜单选择按钮 -->
      <div style="margin-left:2%;margin-right: 2%;font-weight: bold;">玩法类型:</div>
      <el-button type="primary" class="has-dropdown" @click="showCategoryModal" style="min-width:10%;margin-right: 3%;margin-left:3%;">
        {{ selectedCategory || '全部' }}
        <img src="@/assets/xiala.png" alt="" class="custom-icon" />
      </el-button>

    </div>

    <!-- 在查询条件部分下方（或合适位置）新建一行 -->
    <div class = "search-container background-box" style="display: flex; align-items: center; margin-bottom: 20px;">
      <!-- 快速选择按钮 -->
      <div style="margin-right: 2%;font-weight: bold;">玩法榜排名:</div>
      <el-button type="primary" class="has-dropdown" @click="showQuickSelectModal" style="min-width:10%;margin-right: 3%;">
        {{ selectedRankingLabel || '全部玩法' }}
        <img src="@/assets/xiala.png" alt="" class="custom-icon" />
      </el-button>

      <!-- 上线状态 -->
      <div style="margin-right: 2%;font-weight: bold;">上线状态:</div>
      <el-button type="primary" class="has-dropdown" @click="testStatusModalVisible = true" style="margin-right: 20px;">
        {{ selectedTestStatusLabel }}
        <img src="@/assets/xiala.png" alt="" class="custom-icon" />
      </el-button>

      <!-- 活动类型 -->
      <div style="margin-right: 2%;font-weight: bold;">活动类型:</div>
      <el-button type="primary" class="has-dropdown" @click="taskTypeModalVisible = true">
        {{ selectedTaskTypeLabel }}
        <img src="@/assets/xiala.png" alt="" class="custom-icon" />
      </el-button>

      <!-- 查询按钮 -->
      <el-button type="primary" @click="onSearch" style="margin-left:5%;min-width:10%;">查询</el-button>
    </div>

    <!-- 上线状态模态框 -->
    <el-dialog v-model="testStatusModalVisible" title="选择上线状态" width="40%">
      <el-button
          v-for="status in testStatusMenuOptions"
          :key="status.label + '_' + status.value"
          @click="selectTestStatus(status)"
          style="width: 100%; margin: 10px 0;"
      >
        {{ status.label }}
      </el-button>
    </el-dialog>

    <!-- 活动类型模态框 -->
    <el-dialog v-model="taskTypeModalVisible" title="选择活动类型" width="40%">
      <el-button
          v-for="type in taskTypeList"
          :key="type.value"
          @click="selectTaskType(type)"
          style="width: 100%; margin: 10px 0;"
      >
        {{ type.label }}
      </el-button>
    </el-dialog>

    <!-- 榜单选择模态框 -->
    <el-dialog v-model="categoryModalVisible" title="选择类型" width="40%">
      <el-button v-for="category in categories" :key="category" @click="selectCategory(category)" style="width: 100%; margin: 10px 0;">
        {{ category }}
      </el-button>
    </el-dialog>

    <!-- 快速选择模态框 -->
    <el-dialog v-model="quickSelectModalVisible" title="快速选择" width="60%">
      <div class="quick-select-container">
        <el-button v-for="option in quickOptions" :key="option.value" @click="selectRanking(option)" style="width: 100%; margin: 10px 0;">
          {{ option.label }}
        </el-button>
      </div>
      <template #footer>
        <el-button @click="quickSelectModalVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmQuickSelect">确定</el-button>
      </template>
    </el-dialog>

    <!-- 文字广告展示（跑马灯） -->
    <div v-if="textAds.length > 0" class="marquee-ad" style="background-color: rgba(0, 0, 0, 0.5); padding: 5px; margin-top: 3%; margin-bottom: 3%; color: red;">
      <marquee>{{ textAds[0].adv_text }}</marquee>
    </div>

    <!-- 游戏列表表格 -->
    <el-table :data="gamesList" style="width: 100%;" v-if="gamesList.length > 0"
              :header-row-style="headerRowStyle"
              :header-cell-style="headerCellStyle"
              :row-class-name="getRowClassName">
      <el-table-column label="发布日期" prop="launch_date" min-width="15%" :formatter="formatDate"></el-table-column>
      <el-table-column label="游戏信息" min-width="35%">
        <template #default="{ row }">
          <div
              @click="openStartDocument(row.start_document)"
              style="position: relative; width: 100%; height: auto;min-height: 150px; background-size: cover; background-position: center;"
              :style="{
        backgroundImage: `url(${getGameImageUrl(row.game_image)})`
      }"
          >
            <div v-if="row.category" style="position: absolute; top: 10px; left: 10px; background-color: #1ABA99; color: white; padding: 5px;">
              {{ row.category }}
            </div>

            <!-- 登榜奖金池 -->
            <div v-if="row.ranking_task_pool" style="position: absolute; top: 10px; right: 10px; background-color: #02BBB8; color: white; padding: 5px; cursor: pointer;" @click.stop="goToGameTask(row.game_name)">
              登榜奖金池: {{ formatMoney(row.ranking_task_pool) }}
            </div>

            <!-- 开播奖金池 -->
            <div v-if="row.live_task_pool" style="position: absolute; top: 50px; right: 10px; background-color: #1ABA99; color: white; padding: 5px; cursor: pointer;" @click.stop="goToGameTask(row.game_name)">
              开播奖金池: {{ formatMoney(row.live_task_pool) }}
            </div>

            <div
                v-if="row.is_recommended"
                :style="{
          backgroundColor: row.is_recommended === 1 ? 'red' : 'blue',
          color: 'white',
          padding: '5px',
          position: 'absolute',
          top: '10px',
          left: '40%',
          transform: 'translateX(-50%)'
        }"
            >
              {{ row.is_recommended === 1 ? '热' : '荐' }}
            </div>

            <!-- 新增的右下角文本行 -->
            <div v-if="row.start_document"
                 style="position: absolute; bottom: 10px; right: 10px; background-color: #1ABA99; color: white; padding: 5px; cursor: pointer;"
                 @click="openStartDocument(row.start_document)">
              点击查看开播文档
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="游戏详情" min-width="40%">
        <template #default="{ row }">
          <div>
            <div style="font-size: 16px;font-weight: bold;">{{ row.game_name }}
              <span style="margin-right: 5%">
              </span>
              <span :style="{ backgroundColor: row.test_status === 2 ? '#1ABA99' : '#0B79AF' }" style="color: white; padding: 2px;">
                {{ getRowStatusLabel(row.platform, row.test_status) }}
              </span>
            </div>
            <div>
              {{ expandedRows[row.game_name] ? row.game_description : row.game_description.slice(0, 50) }}...
              <el-button type="text" @click="toggleDescription(row)">
                {{ expandedRows[row.game_name] ? '收起' : '展开更多' }}
              </el-button>
            </div>
            <el-button v-if="row.game_video" type="primary" @click="showVideo(row.game_video)">玩法视频</el-button>
            <el-button v-if="row.invite_code" type="default" @click="showInviteModal(row.invite_code)">点我进群</el-button>
            <el-button type="default" @click="goToGameTask(row.game_name)">活动数据</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 在模板中添加模态对话框 -->
    <el-dialog v-model="videoDialogVisible" title="玩法视频" width="60%">
      <div style="text-align:center;">
        <video v-if="videoUrl" :src="'https://www.hudongwanfa.cn/' + videoUrl" controls autoplay style="width:100%"></video>
        <div v-else>没有视频链接</div>
      </div>
      <template #footer>
        <el-button @click="videoDialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>

    <!-- 分页 -->
    <el-pagination v-if="totalGames > 0" :current-page="currentPage" :page-size="perPage" :total="totalGames" @current-change="onPageChange" layout="prev, pager, next, jumper" style=" min-height:40px;margin-top: 20px;justify-content: center; "/>

    <!-- 图片广告 -->
    <div v-if="imageAds.length > 0" class="image-ads-container" style="display: flex; justify-content: space-between; margin-top: 20px;">
      <div class="image-ad" v-for="ad in imageAds" :key="ad.id"
           :style="{
         flex: '1',
         margin: '10px',
         position: 'relative',
         backgroundImage: 'url(' + ad.adv_img_url + ')',
         backgroundSize: 'cover',
         height: '150px',
         cursor: 'pointer'
       }"
           @click="openStartDocument(ad.start_doc_url)">
        <div style="position: absolute; top: 10px; left: 10px; background-color: #1ABA99; color: white; padding: 5px;">
          点击查看开播文档
        </div>
        <div style="position: absolute; bottom: 10px; right: 10px; background-color: #1ABA99; color: white; padding: 5px;">
          一键进群
        </div>
      </div>
    </div>

    <!-- 加载中提示 -->
    <el-dialog v-model="isLoading" width="100px" :show-close="false">
      <div style="text-align:center;">数据加载中，请稍后…</div>
      <el-icon><el-loading /></el-icon>
    </el-dialog>
  </div>

  <!-- 在 <el-dialog v-model="videoDialogVisible">…</el-dialog> 后面，添加： -->
  <el-dialog
      v-model="inviteDialogVisible"
      title="进群指南"
      width="400px"
      :footer="null"
  >
    <div style="text-align:center; line-height:1.8;">
      <!-- 1. 显示邀请码 -->
      <div style="font-size:20px; font-weight:bold; margin-bottom:10px;">
        {{ currentInviteCode }}
      </div>
      <!-- 2. 复制按钮 -->
      <el-button type="primary" @click="copyInviteCode">复制</el-button>
      <!-- 3. 三行文字 -->
      <p>① 点击☝复制进群密钥</p>
      <p>② 电脑端搜索微信号：danmukefu</p>
      <p>② 手机端：识别👇的二维码</p>
      <!-- 4. 二维码图片 -->
      <img
          src="https://www.hudongwanfa.cn/storage/qa/qa_qr_code1.jpg"
          alt="客服二维码"
          style="width:200px; height:auto; margin:10px auto; display:block;"
      />
      <!-- 5. 发送进群密钥提示 -->
      <p>③ 发送进群密钥给👇客服微信</p>
      <!-- 6. 客服微信二维码 -->
      <img
          src="https://xymcm.cn/static/background/%E8%81%8A%E5%A4%A9.jpg"
          alt="客服微信"
          style="width:200px; height:auto; margin:10px auto; display:block;"
      />
    </div>
  </el-dialog>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';  // ← 新增
import './NewGameList.css'
import { ElTable, ElTableColumn, ElButton, ElDialog, ElPagination, ElIcon, ElLoading } from 'element-plus';
import axios from 'axios';
import defaultCover from '@/assets/暂无图片.jpg';

export default {
  components: {
    ElTable,
    ElTableColumn,
    ElButton,
    ElDialog,
    ElPagination,
    ElIcon,
    ElLoading
  },
  setup() {
    // 定义响应式数据
    const displayTime = ref(new Date().toLocaleDateString());
    const selectedCategory = ref(null);
    const selectedRanking = ref(null);
    const selectedRankingLabel = ref('全部玩法');
    const gamesList = ref([]);
    const totalGames = ref(0);
    const currentPage = ref(1);
    const perPage = ref(8);
    const isLoading = ref(false);

    // 模态框显示控制
    const categoryModalVisible = ref(false);
    const quickSelectModalVisible = ref(false);
    const videoDialogVisible = ref(false);
    const videoUrl = ref('');
    const showSuggestions = ref(false);

    const textAds = ref([]);  // 存储文字广告
    const imageAds = ref([]);  // 存储图片广告

    const categories = ['对战', '角力', '攻防', '比赛', '竞速', '养成', '闯关', '整蛊', '音舞', '全部'];
    const quickOptions = [
      { label: '三月内前20名', value: 'top20' },
      { label: '三月内前50名', value: 'top50' },
      { label: '全部玩法', value: 'all' }
    ];

    // 平台名映射：统一到 '抖音' / '快手'
    const normalizePlatform = (p) => {
      if (!p) return null
      if (p === 'dy' || p === '抖音' || p === 'douyin') return '抖音'
      if (p === 'ks' || p === '快手' || p === 'kuaishou') return '快手'
      return null
    }

    // 行内小标签：根据【行】的 platform + test_status 组合出“抖音公测/快手内测”等
    const getRowStatusLabel = (platform, status) => {
      const plat = normalizePlatform(platform)
      if (!plat) return status === 1 ? '公测' : status === 2 ? '内测' : '未知'
      if (status === 1) return `${plat}公测`
      if (status === 2) return `${plat}内测`
      return '未知'
    }

    // 将后端字段转换成可用的图片 URL，若为空则回退到本地占位图
    const getGameImageUrl = (imgPath) => {
      if (imgPath === null || imgPath === undefined) return defaultCover;
      const s = String(imgPath).trim();
      if (!s || s === '0' || s.toLowerCase() === 'null' || s.toLowerCase() === 'undefined') {
        return defaultCover;
      }
      // 已是绝对地址直接返回；否则拼接站点前缀
      if (/^https?:\/\//i.test(s)) return s;
      return `https://www.hudongwanfa.cn/${s}`;
    };

    const testStatusMenuOptions = computed(() => {
      // 收集去重的 (platform,status)
      const mark = new Set()
      const opts = []

      for (const row of gamesList.value || []) {
        const plat = normalizePlatform(row.platform)
        const st = Number(row.test_status)
        if (!plat || (st !== 1 && st !== 2)) continue
        const key = `${plat}-${st}`
        if (!mark.has(key)) {
          mark.add(key)
          opts.push({
            label: st === 1 ? `${plat}公测` : `${plat}内测`,
            value: st        // 关键：value 仍然只有 1 或 2
          })
        }
      }

      // 排序：平台（抖音→快手），状态（公测→内测）
      const orderPlat = { '抖音': 0, '快手': 1 }
      const orderStatus = { 1: 0, 2: 1 }
      opts.sort((a, b) => {
        const [ap, as] = a.label.includes('抖音') ? ['抖音', a.value] : ['快手', a.value]
        const [bp, bs] = b.label.includes('抖音') ? ['抖音', b.value] : ['快手', b.value]
        return (orderPlat[ap] - orderPlat[bp]) || (orderStatus[as] - orderStatus[bs])
      })

      // 永远把“全部”放在最前
      return [{ label: '全部', value: null }, ...opts]
    })

    // 从 URL 初始化搜索参数并触发查询
    const initFromUrl = () => {
      const params = new URLSearchParams(window.location.search)
      const gm = params.get('game_name')
      if (gm) {
        // URLSearchParams 会自动解码，无需再次 decode
        searchQuery.value = gm
        currentPage.value = 1   // 重置到第一页
        fetchGames()            // 立即按关键词拉取数据
        return true
      }
      return false
    }


    // 管理展开的行
    const expandedRows = ref({});

    // 定义响应式数据
    const searchQuery = ref('');

    const filteredSuggestions = ref([]);
    const dropdownStyle = ref({});

    // —— 平台名（从接口数据推断），默认抖音 ——
    // 可选值预期：'抖音' | '快手'
    const platformName = ref('抖音')

    // 根据平台动态生成“上线状态”选项文案
    const testStatusList = computed(() => ([
      { label: `${platformName.value}公测`, value: 1 },
      { label: `${platformName.value}内测`, value: 2 },
      { label: '全部', value: null }
    ]))

    // 行内状态文案
    const getPlatformStatusLabel = (status) => {
      if (status === 1) return `${platformName.value}公测`
      if (status === 2) return `${platformName.value}内测`
      return '未知'
    }

    // 加载广告数据
    const fetchAds = async () => {
      try {
        const response = await axios.get('https://www.hudongwanfa.cn/api/adv');
        textAds.value = response.data.text_ads || [];
        imageAds.value = response.data.image_ads || [];
      } catch (error) {
        console.error('Error fetching ads data:', error);
      }
    };

    // 计算popper位置
    const adjustDropdownPosition = () => {
      const inputElement = document.querySelector('.autocomplete-input');
      if (inputElement && showSuggestions.value) {
        const currentWidth = window.innerWidth;
        if (currentWidth <= 768) {
          // console.log('111111 autocompleteElement.style.top=', inputElement.style.top, ' autocompleteElement.style.left', inputElement.style.left);
          //
          // let scale = 768 / window.innerWidth;
          // inputElement.style.top = `${scale * parseFloat(inputElement.style.top)}px`;
          // inputElement.style.left = `${scale * parseFloat(inputElement.style.left)}px`;
          // // console.log('windows is', window)
          // console.log('22222 autocompleteElement.style.top=', inputElement.style.top, ' autocompleteElement.style.left', inputElement.style.left);

          // const rect = inputElement.getBoundingClientRect();
          // dropdownStyle.value = {
          //   top: `${rect.bottom + window.scrollY}px`,
          //   left: `${rect.left + window.scrollX}px`,
          //   width: `${rect.width}px`
          // };
        }
      }
    };

    // 加载游戏数据
    const fetchGames = async () => {
      isLoading.value = true;
      const params = {
        game_name: searchQuery.value,
        category: selectedCategory.value,
        ranking_condition: selectedRanking.value === 'all' ? undefined : selectedRanking.value,
        paginate: perPage.value,
        page: currentPage.value,
      };

      if (testStatusValue.value) {
        params.test_status_exact = testStatusValue.value;
      }
      if (taskTypeValue.value) {
        params.task_type = taskTypeValue.value;
      }

      try {
        const response = await axios.get('https://www.hudongwanfa.cn/api/new_game_list', { params });
        gamesList.value = response.data.data;
        totalGames.value = response.data.meta.total;

        // —— 从返回里识别平台（优先读首条的 platform 字段）——
        const first = gamesList.value && gamesList.value.length ? gamesList.value[0] : null
        if (first && first.platform) {
          // 你后端的 platform 可能是 'dy'/'ks'，或者直接是 '抖音'/'快手'
          // 这里做一个保险转换：
          const p = first.platform
          platformName.value = (p === 'dy' || p === '抖音') ? '抖音'
              : (p === 'ks' || p === '快手') ? '快手'
                  : '抖音' // fallback
        }

        // —— 如果之前选中过“公测/内测”，切平台后把面板按钮上的文案也同步 ——
        if (testStatusValue.value === 1) {
          selectedTestStatusLabel.value = `${platformName.value}公测`
        } else if (testStatusValue.value === 2) {
          selectedTestStatusLabel.value = `${platformName.value}内测`
        } else {
          selectedTestStatusLabel.value = '全部'
        }

      } catch (error) {
        console.error('Error fetching game data:', error);
      } finally {
        isLoading.value = false;
      }
    };

    // 格式化日期
    const formatDate = (row) => {
      return new Date(row.launch_date).toLocaleDateString();
    };

    // 格式化奖金池
    const formatMoney = (amount) => {
      return amount ? `${(amount / 10000)}万` : '无';
    };

    // 展开或收起玩法介绍
    const toggleDescription = (row) => {
      expandedRows.value[row.game_name] = !expandedRows.value[row.game_name];
    };

    // 页面切换
    const onPageChange = (page) => {
      currentPage.value = page;
      fetchGames();
    };

    // 查询按钮点击
    const onSearch = () => {
      fetchGames();
    };

    // 显示视频模态框
    const showVideo = (url) => {
      videoUrl.value = url;
      videoDialogVisible.value = true;
    };

    // 显示未开放提示
    const showNotAvailable = () => {
      alert('暂未开放');
    };

    // 模态框选择类别
    const showCategoryModal = () => {
      categoryModalVisible.value = true;
    };

    const selectCategory = (category) => {
      selectedCategory.value = category === '全部' ? null : category;
      fetchGames();
      categoryModalVisible.value = false;
    };

    // 选择玩法
    const selectRanking = (option) => {
      selectedRanking.value = option.value;
      selectedRankingLabel.value = option.label;
      fetchGames();
      quickSelectModalVisible.value = false;
    };

    // 模态框快速选择
    const showQuickSelectModal = () => {
      quickSelectModalVisible.value = true;
    };

    // 确认快速选择
    const confirmQuickSelect = () => {
      fetchGames();
      quickSelectModalVisible.value = false;
    };

    // 处理用户输入
    const onSearchInput = async () => {
      const query = searchQuery.value.trim();
      if (query) {
        try {
          const response = await axios.get('https://www.hudongwanfa.cn/api/search_game', {
            params: { game_name: query }
          });
          filteredSuggestions.value = response.data.data.map(item => ({
            label: item.game_name,
            value: item.game_name
          }));
        } catch (error) {
          console.error('Error fetching game suggestions:', error);
        }
      } else {
        filteredSuggestions.value = [];
      }
    };

    // 显示下拉框
    const showDropdown = () => {
      showSuggestions.value = true;
      adjustDropdownPosition();
    };

    // 隐藏下拉框
    const hideSuggestions = () => {
      setTimeout(() => {
        showSuggestions.value = false;
      }, 100); // 延迟隐藏，避免点击下拉项时消失
    };

    // 选择游戏
    const onGameSelect = (item) => {
      searchQuery.value = item.label;
      showSuggestions.value = false;
    };

    // 获取行的 class name，用于设置不同的行颜色
    function getRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row'
    }

    // 12. 表头单元格样式
    function headerCellStyle() {
      return {
        backgroundColor: '#4a649e',
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
        fontSize: '16px'
      }
    }

    // 13. 表头行样式
    function headerRowStyle() {
      return { backgroundColor: '#f2f2f2', fontWeight: 'bold' };
    }

    const openStartDocument = (url) => {
      // 跳转到 row.start_document 指定的链接
      window.location.href = url;
    };

    // 额外增加的响应式变量（放在 setup() 中即可）
    // 1) 上线状态
    const testStatusModalVisible = ref(false);
    const selectedTestStatusLabel = ref('全部'); // 初始显示文案
    const testStatusValue = ref(null);          // 具体传给后端的值

    // 2) 活动类型
    const taskTypeModalVisible = ref(false);
    const taskTypeList = [
      { label: '登榜任务', value: 2 },
      { label: '开播任务', value: 1 },
      { label: '无', value: null }
    ];
    const selectedTaskTypeLabel = ref('无'); // 初始显示文案
    const taskTypeValue = ref(null);         // 具体传给后端的值

    // 点击选择“上线状态”
    function selectTestStatus(status) {
      testStatusValue.value = status.value;        // null / 1 / 2
      selectedTestStatusLabel.value = status.label // '全部' 或 '抖音公测' 等
      fetchGames();
      testStatusModalVisible.value = false;
    }

    // 点击选择“活动类型”
    function selectTaskType(type) {
      taskTypeValue.value = type.value;
      selectedTaskTypeLabel.value = type.label;
      fetchGames(); // 重新请求数据
      taskTypeModalVisible.value = false;
    }

    // —— 新增：邀请模态框相关 ——
    const inviteDialogVisible = ref(false);
    const currentInviteCode   = ref('');

    /** 打开邀请模态框 */
    function showInviteModal(code) {
      currentInviteCode.value = code;
      inviteDialogVisible.value = true;
    }

    /** 复制到剪贴板 */
    async function copyInviteCode() {
      try {
        await navigator.clipboard.writeText(currentInviteCode.value);
        ElMessage.success('进群密钥已复制');
      } catch (err) {
        ElMessage.error('复制失败，请手动复制');
      }
    }

    // 在 setup() 中添加新的方法
    const goToGameTask = (gameName) => {
      // 使用 window.location.href 跳转到游戏的任务页面
      window.location.href = `/game_task?game_name=${encodeURIComponent(gameName)}`;
    };

    /** 跳转到后端 /wechat/subscribe **/
    function goSubscribe() {
      window.location.href = 'https://www.hudongwanfa.cn/wechat/subscribe'
    }

    watch(gamesList, () => {
      const menu = testStatusMenuOptions.value
      // 如果当前是“全部”，不处理
      if (testStatusValue.value == null) return
      // 菜单里还有同 label 的就不动
      if (menu.some(x => x.label === selectedTestStatusLabel.value)) return
      // 用相同 value 的第一项替代文案（比如 '公测' 的第一项）
      const alt = menu.find(x => x.value === testStatusValue.value)
      if (alt) selectedTestStatusLabel.value = alt.label
    })

    // 初始化加载数据
    onMounted(() => {
      fetchAds();
      initFromUrl();   // 只设置 searchQuery，不在这里 fetch
      fetchGames();                    // 始终只拉一次（会带着 searchQuery）
    });

    return {
      displayTime,
      searchQuery,
      selectedCategory,
      selectedRanking,
      selectedRankingLabel,
      gamesList,
      totalGames,
      currentPage,
      perPage,
      isLoading,
      categories,
      quickOptions,
      videoDialogVisible,
      categoryModalVisible,
      quickSelectModalVisible,
      testStatusModalVisible,
      taskTypeModalVisible,
      videoUrl,
      expandedRows,
      textAds,
      imageAds,
      testStatusList,
      taskTypeList,
      selectedTestStatusLabel,
      selectedTaskTypeLabel,
      fetchGames,
      formatDate,
      formatMoney,
      onPageChange,
      onSearch,
      showVideo,
      showNotAvailable,
      showCategoryModal,
      selectCategory,
      selectRanking,
      showQuickSelectModal,
      confirmQuickSelect,
      toggleDescription,
      onSearchInput,
      onGameSelect,
      getRowClassName,
      headerCellStyle,
      headerRowStyle,
      showSuggestions,
      hideSuggestions,
      dropdownStyle,
      filteredSuggestions,
      showDropdown,
      openStartDocument,
      selectTestStatus,
      selectTaskType,
      inviteDialogVisible,
      currentInviteCode,
      showInviteModal,
      copyInviteCode,
      goToGameTask,
      platformName,
      getPlatformStatusLabel,
      testStatusMenuOptions,
      testStatusValue,
      getRowStatusLabel,
      getGameImageUrl,
      goSubscribe
    };
  }
};
</script>

<style scoped>
.el-pagination {
  --el-pagination-button-width: 50px !important;
  --el-pagination-button-height: 50px !important;
  --el-pagination-font-size: 24px !important;
}

.custom-autocomplete {
  position: relative;
}

.autocomplete-input {
  width: 100%;
  padding: 8px;
  font-size: 16px;
}

/* 样式优化，确保下拉框显示不会超出屏幕范围 */
.autocomplete-dropdown {
  position: absolute;
  z-index: 9999;
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ccc;
  background-color: white;
  width: 100%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  padding: 8px;
  font-size: 16px;
}

.dropdown-item {
  padding: 8px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}
</style>